export class TranslationPt {

  static readonly dict =
    {
      'pages.security.login.title': 'Início de sessão',
      'pages.security.login.input_email_placeholder': 'E-mail',
      'pages.security.login.input_password_placeholder': 'Password',
      'pages.security.login.input_email_validation_required': 'O campo do e-mail é obrigatório',
      'pages.security.login.input_password_validation_required': 'O campo da password é obrigatório',
      'pages.security.login.button_sign_in': 'Entrar',
      'pages.security.login.modals.error.title': 'Erro ao fazer login',
      'pages.security.login.modals.error.body': 'Por favor confirme as suas credenciais',
      'pages.security.login.modals.invalid.title': 'Credenciais inválidas',
      'pages.security.login.modals.invalid.body': 'Por favor confirme as suas credenciais',
      'pages.security.login.forgot_password': 'Esqueceu-se da sua password?',
      'pages.leads.lead': 'Lead',
      'pages.leads.calendar': 'Calendario',
      'pages.leads.leads': 'Leads',
      'pages.leads.status': 'Estado',
      'pages.leads.status.type.prequalification': 'pages.leads.status.type.prequalification',
      'pages.leads.status.type.buyed': 'pages.leads.status.type.buyed',
      'pages.leads.status.type.notbuyed': 'pages.leads.status.type.notbuyed',
      'pages.leads.pending': 'Pendente',
      'pages.leads.new': 'Novo',
      'pages.leads.news': 'Novos',
      'pages.leads.open': 'Aberto',
      'pages.leads.assigned_to': 'Assignado a ',
      'pages.leads.assigned': 'Assignado',
      'pages.leads.bemycar_update': 'pages.leads.bemycar_update',
      'pages.leads.user': 'Utilizador',
      'pages.leads.brand': 'Marca',
      'pages.leads.channel': 'Canal',
      'pages.leads.type': 'Tipo',
      'pages.leads.description_model': 'Modelo de Interesse',
      'pages.leads.model': 'Modelo',
      'pages.leads.dealer': 'Instalação',
      'pages.leads.created_at': 'Entrada',
      'pages.leads.updated_at': 'pages.leads.updated_at',
      'pages.leads.actions': 'Ações',
      'pages.leads.address': 'Morada',
      'pages.leads.type.used_vehicle': 'VU',
      'pages.leads.type.new_vehicle': 'VN',
      'pages.leads.type.after_sale': 'Pós-Venda',
      'pages.leads.type.fleet': 'Frotas',
      'pages.leads.type.commercial': 'Veículos comerciais',
      'pages.leads.type.renting': 'Renting',
      'pages.leads.type.rent_a_car': 'Rent a Car',
      'pages.leads.type.unknow': 'Sem especificar',
      'pages.leads.type.': 'Sem especificar',
      'pages.leads.status.new': 'Nova Lead',
      'pages.leads.status.closed': 'Venda finalizada',
      'pages.leads.status.archived': 'Arquivado',
      'pages.leads.status.on_track': 'Em seguimento',
      'pages.leads.status.cold': 'Frio',
      'pages.leads.status.warm': 'Morno',
      'pages.leads.status.hot': 'Quente',
      'pages.leads.has_phone': 'Tem telefone',
      'pages.leads.has_email': 'Tem e-mail',
      'pages.leads.tags.new': 'Novo',
      'pages.leads.tags.defeated': 'Expirado',
      'pages.leads.tags.expiration': 'expiração',
      'pages.leads.tags.24h': '24h',
      'pages.leads.tags.48h': '48h',
      'pages.leads.tags.today': 'Hoje',
      'pages.leads.tags.prequalification': 'Precualificación',
      'pages.leads.browse_files': 'Examinar arquivos',
      'pages.leads.drop_file_here': 'Solte o ficheiro aqui',
      'pages.leads.archive': 'pages.leads.archive',
      'shared.select_all': 'Seleccionar tudo',
      'shared.label_not_found': 'shared.label_not_found',
      'shared.create_new_origin': 'shared.create_new_origin',
      'shared.unselect_all': 'Desmarcar tudo',
      'shared.search': 'Procurar',
      'shared.users': 'Utilizadores',
      'shared.modules': 'Módulos',
      'shared.load_more': 'Carregar mais',
      'shared.companies': 'shared.companies',
      'shared.channels': 'Canais',
      'shared.dealers': 'Instalações',
      'shared.brands': 'Marcas',
      'shared.types': 'Tipos de Lead',
      'shared.select_element': 'Seleccione um elemento',
      'leadType.new_vehicle': 'Veículo novo',
      'leadType.used_vehicle': 'Ocasião',
      'leadType.after_sale': 'Pós-Venda',
      'leadType.fleet': 'Frotas',
      'leadType.commercial': 'Veículos comerciais',
      'leadType.': 'Outros',
      'leadType.renting': 'Renting',
      'chart.lead_type.rent_a_car': 'Rent a Car',
      'chart.lead_type.new_vehicle': 'Veículo novo',
      'chart.lead_type.used_vehicle': 'Ocasião',
      'chart.lead_type.after_sale': 'Pós-Venda',
      'chart.lead_type.fleet': 'Frotas',
      'chart.lead_type.commercial': 'Veículos comerciais',
      'chart.lead_type.': 'Outros',
      'chart.lead_type.renting': 'Renting',
      'dealer.leads.chart.no_dealer': 'dealer.leads.chart.no_dealer',
      'header.new_lead.title': 'Nova Lead',
      'pages.leads.select_all': 'Seleccionar tudo',
      'pages.leads.unselect_all': 'Desmarcar tudo',
      'pages.leads.search': 'Procurar',
      'pages.leads.users': 'Utilizadores',
      'pages.leads.channels': 'Canais',
      'pages.leads.dealers': 'Instalações',
      'pages.leads.brands': 'Marcas',
      'pages.leads.select_element': 'Seleccione um elemento',
      'pages.leads.select_element.error': 'Selecione pelo menos um elemento',
      'pages.leads.name': 'Nome',
      'pages.leads.phone': 'Telefone',
      'pages.leads.email': 'E-mail',
      'pages.leads.vat': 'NIF',
      'pages.leads.others_f': 'Outras',
      'pages.leads.today': 'Hoje',
      'pages.leads.yesterday': 'Ontem',
      'pages.leads.tomorrow': 'Amanhã',
      'pages.leads.hour': 'hora',
      'pages.leads.hours': 'horas',
      'pages.leads.day': 'dia',
      'pages.leads.days': 'días',
      'pages.leads.month': 'Mês',
      'pages.leads.months': 'Meses',
      'pages.leads.from': 'Desde',
      'pages.leads.to': 'Até',
      'pages.leads.apply': 'Aplicar',
      'pages.leads.reset_filter': 'pages.leads.reset_filter',
      'pages.leads.visit': 'Compromisso',
      'pages.leads.appointment': 'Compromisso',
      'pages.leads.appointments': 'Compromissos',
      'pages.leads.reminder': 'Lembrete',
      'pages.leads.reminders': 'Lembretes',
      'pages.leads.transfereds': 'Transferidos',
      'pages.leads.contacteds': 'Contactados',
      'pages.leads.select_option': 'Seleccione uma opção',
      'pages.leads.assign': 'Assignar',
      'pages.leads.transfer': 'Transferir',
      'pages.leads.delete': 'Apagar',
      'pages.leads.comments': 'Comentário',
      'pages.leads.put_your_comment': 'Coloque o seu comentário',
      'pages.leads.description': 'Descrição',
      'pages.leads.custom_filter.advise': 'Um dos filtros customizados está activo, retire-o para para poder utilizar este filtro',
      'pages.leads.import.error.headers': 'O cabeçalho do fichero csv não está correcto.',
      'pages.leads.import.error.type_not_found': 'O tipo indicado não é válido. Valores admitidos VN / VU / Pós-Venda / Vazio',
      'pages.leads.origin': 'Origem',
      'pages.leads.shipping': 'Remessa',
      'toaster.add_comment.success.title': 'Comentário adicionado',
      'toaster.add_comment.error.title': 'Erro ao adicionar comentário',
      'toaster.add_comment.success.body': 'O comentário foi adicionado correctamente.',
      'toaster.title.lead_reminder_success': 'Lembrete adicionado',
      'toaster.lead_reminder_success': 'O lembrete foi correctamente adicionado à Lead ',
      'toaster.lead_remove_event_success': 'toaster.lead_remove_event_success',
      'toaster.title.lead_remove_event_success': 'toaster.title.lead_remove_event_success',
      'toaster.lead_transfered_success': 'Lead transferida correctamente.',
      'toaster.lead_transfered_success_body': 'As leads seleccionadas foram transferidas correctamente.',
      'toaster.lead.transfered.error': 'Erro ao transferir uma lead',
      'toaster.lead.get.error': 'Erro ao recuperar a lead',
      'toaster.lead.transfered.error.body': 'Ocorreu um erro inesperado na transferência da Lead',
      'toaster.lead.assigned_success': 'Lead assignada correctamente.',
      'toaster.lead.assigned_sucess_body': 'As Leads seleccionados foram assignadas correctamente.',
      'toaster.lead.assigned.error': 'Erro ao assignar a Lead',
      'toaster.lead.assigned.error.body': 'Ocorreu um erro inesperado na assignação da Lead',
      'toaster.lead.deleted.success': 'Lead eliminada correctamente',
      'toaster.lead.deleted.success.body': 'As leads seleccionadas foram eliminadas correctamente',
      'toaster.lead.deleted.error': 'Erro ao eliminar a lead',
      'toaster.lead.deleted.error.body': 'Ocorreu um erro inesperado na eliminação da Lead',
      'toaster.new.lead.success': 'Lead criada correctamente',
      'toaster.new.lead.success.body': 'A lead foi criada correctamente',
      'toaster.new.lead.error': 'Erro na criação da lead',
      'toaster.new.lead.error.body': 'Ocorreu um erro inesperado na criação da lead',
      'toaster.edit.lead.success': 'Lead editada correctamente.',
      'toaster.edit.lead.success.body': 'A lead seleccionada foi editada correctamente',
      'toaster.edit.lead.error': 'Erro ao editar uma lead',
      'toaster.edit.lead.error.body': 'Ocorreu um erro inesperado na edição da lead',
      'toaster.call.error': 'Não se realizou a chamada',
      'toaster.call.error.body': 'A chamada não foi realizada correctamente',
      'toaster.call.error.body.another.started.call': 'Há outra chamada em curso',
      'toaster.call.success': 'Chamada finalizada com êxito',
      'toaster.call.success.body': 'A chamada foi completada satisfactoriamente',
      'toaster.visit_confirmation.success': 'Relatório de visita concluído com êxito',
      'toaster.visit_confirmation.body': 'O relatório da visita foi completado satisfactoriamente',
      'toaster.call.error.no_equal_lead_id': 'Problema ao recuperar informações de lead. Tente de novo.',
      'toaster.email.error': 'Erro no envio de e-mail',
      'toaster.lead.on_track': 'Lead em seguimento',
      'toaster.lead.status_on_track_changed': 'O estado de seguimento da lead foi atualizado',
      'toaster.whatsapp.error': 'Erro no envio de WhatsApp',
      'toaster.whatsapp.succes.title': 'Whatsapp enviado',
      'toaster.whatsapp.success_body': 'Mensagem whatsapp enviada correctamente',
      'toaster.quotations.load.error': 'Erro ao carregar os orçamentos',
      'toaster.integration.success': 'Integração bem sucedida',
      'toaster.integration.success_body': 'O lead foi corretamente integrado ao sistema externo',
      'toaster.integration.error': 'Integração mal sucedida',
      'modals.transfer_leads_title': 'Transferir Leads',
      'modals.select_user_to_transfer_lead': 'Seleccione um utilizador para transferir as Leads: ',
      'page.mylead.no_especificado': 'Não especificado',
      'pages.mylead.details.createdat': 'Entrou',
      'pages.mylead.details.new_vehicle': 'Veículo novo',
      'pages.mylead.details.used_vehicle': 'Veículo Usado',
      'pages.mylead.details.after_sale': 'Pós-Venda',
      'pages.mylead.details.fleet': 'Frotas',
      'pages.mylead.details.commercial': 'Veículos comerciais',
      'pages.mylead.details.unknow': 'Sem especificar',
      'pages.mylead.details.unnasigned': 'Sem assignar',
      'pages.mylead.exclusive.lead': 'Lead atribuído a: ',
      'pages.mylead.remove': 'pages.mylead.remove', // TODO translate
      'pages.mylead.tab.concurrences': 'pages.mylead.tab.concurrences',
      'pages.mylead.tab.quotations': 'pages.mylead.tab.quotations',
      'pages.mylead.tab.events': 'pages.mylead.tab.events',
      'pages.mylead.tab.historic': 'pages.mylead.tab.historic',
      'pages.mylead.tab.interaction': 'pages.mylead.tab.interaction',
      'pages.mylead.tab.lead': 'pages.mylead.tab.lead',
      'pages.mylead.tab.metric': 'pages.mylead.tab.metric',
      'pages.mylead.tab.crm': 'Compartir',
      'pages.mylead.appointment_remove': 'pages.mylead.appointment_remove', // TODO translate
      'pages.notice.url.show_more': 'pages.notice.url.show_more',
      'pages.leads.leads_per_page': 'Leads por página',
      'modals.archived_lead.title': 'Arquivar Lead',
      'modals.archive.comments.required': 'Comentário obrigatório',
      'modals.archive.archived_option.required': 'Seleccione uma opção',
      'modals.complete_name': 'Nome e apelidos',
      'modals.importer.button': 'Importar',
      'modals.save.button': 'Guardar',
      'modals.next.button': 'Próximo passo',
      'modals.import.title': 'Importar leads desde fichero CSV',
      'modals.importer.instructions.header': 'Importar fichero (csv)',
      'modals.importer.instructions.format_should_csv': 'Formato do fichero a importar deve ser .csv',
      'modals.importer.instructions.separator_fields': 'Separador de campos ponto e virgula";".',
      'modals.importer.instructions.delimiter_quotes': 'Delimitador de texto aspas ".',
      'modals.importer.instructions.headers_valids':
        ' Não se terá em conta a primera fila de cabeçalhos, mas deve ser cumprida a ordem das colunas. Pode descarregar um template ',
      'modals.importer.instructions.headers_valids_here': 'aquí',
      'modals.importer.file': 'Ficheiro',
      'modals.importer.columns_is_not_correct': 'Não contêm as colunas correctas',
      'modals.importer.dealer_not_found': 'Não se encontradou a instalação',
      'modals.importer.brand_not_found': 'Não se encontrou a marca',
      'modals.importer.channel_not_found': 'Não se encontrou o canal',
      'modals.importer.email_phone_is_required': 'E-mail/Telefone são campos requeridos',
      'modals.importer.phone_invalid': 'modals.importer.phone_invalid',
      'modals.importer.name_is_a_required_field': 'O nome e apelidos é campo obrigatório.',
      'modals.importer.validating_headers': 'A validar cabeçalhos',
      'modals.importer.validating_lead_columns': 'A validar colunas',
      'modals.importer.check_fields': 'A validar campos',
      'modals.importer.validating_channels': 'A validar canais',
      'modals.importer.validating_brands': 'A validar marcas',
      'modals.importer.validating_dealers': 'A validar instalações',
      'modals.importer.validating_types': 'A validar tipos',
      'modals.importer.preparing_new_leads': 'Preparando leads',
      'modals.importer.creating_new_leads': 'A criar novas Leads',
      'modals.importer.instructions.codification': 'Codificação UTF-8',
      'modals.importer.instructions.info_channel': 'As informações de Canal / Marca / Tipo / Instalação devem ser iguais às exibidas nos menus suspensos da secção de filtros.',
      'modals.importer.instructions.postal_code': 'A informação do Código Postal "CP" tem que ser apenas os dígitos do código.',
      'modals.send.button': 'Enviar',
      'modals.retry_import.button': 'Voltar a carregar o fichero',
      'modals.cancel.button': 'Cancelar',
      'modals.close.button': 'Fechar',
      'modals.close.comments.required': 'Comentário obrigatorio',
      'modals.assign.button': 'Assignar',
      'modals.delete.button': 'Eliminar',
      'modals.delete.comments.required': 'Comentário obrigatório',
      'modals.transfer.button': 'Transferir',
      'modals.assign.leads.title': 'Assignar Leads',
      'modals.close_sale.title': 'Finalizar venda ',
      'modals.select_user_to_assign_lead': 'Seleccione um utilizador para assignar as leads: ',
      'modals.delete.leads.title': 'Tem a certeza?',
      'modals.are.you.sure.delete.this.lead': 'Tem a certeza que quer eliminar esta lead?',
      'modals.reminder.title': 'Lembrete',
      'modals.reminder.this_lead_already_has_a_reminder': 'modals.reminder.this_lead_already_has_a_reminder', // TODO Translate
      'modals.send_mail.title': 'Envio de e-mail',
      'modals.send_mail.subject': 'Assunto',
      'modals.send_mail.write_your_email': 'Redija o seu e-mail',
      'modals.send_mail.subject.required': 'Assunto obrigatório',
      'modals.send_mail.body.required': 'Corpo da mensagem obrigatório',
      'modals.call.title': 'Resultado da interacção',
      'modals.call.finish_call_form.on_track_status.required': 'Seleccione uma opção',
      'modals.call.finish_call_form.comments.required': 'Comentário obrigatório',
      'modals.new.lead.title': 'Nova Lead',
      'modals.edit.lead.title': 'Editar Lead',
      'modals.send_whatsapp.title': 'Enviar WhatsApp',
      'modals.send_whatsapp.write_your_whatsapp': 'Redija a sua mensagem: ',
      'modals.appointment.title': 'Compromisso',
      'modals.appointment.this_lead_already_has_a_appointment': 'Este lead já tem um compromisso agendado',
      'modals.appointment.choose_when': 'Data da compromisso: ',
      'modals.send_whats_app.comments.required': 'Comentário obrigatório',
      'modals.on_track.title': 'Interacção',
      'modals.on_track.on_track_status.required': 'Seleccione uma opção',
      'modals.on_track.comments.required': 'Comentário obrigatório',
      'modals.comment.add_comment': 'Adicionar comentário',
      'modals.next_steps': 'modals.next_steps',
      'funnel.total.leads': 'Novas Leads',
      'funnel.contacted.leads': 'Contactados',
      'funnel.visited.leads': 'Visitas',
      'funnel.closed.leads': 'Vendas finalizadas',
      'lead_archived_type.not_contacted': 'Não se conseguiu contactar',
      'lead_archived_type.not_interested': 'Não interessado',
      'lead_archived_type.other': 'Outros',
      'lead_archived_type.by_price': 'lead_archived_type.by_price',
      'lead_archived_type.by_appraisal': 'lead_archived_type.by_appraisal',
      'lead_archived_type.by_financing': 'lead_archived_type.by_financing',
      'lead_archived_type.immature': 'lead_archived_type.immature',
      'lead_archived_type.samebrand': 'lead_archived_type.samebrand',
      'lead_archived_type.anotherbrand': 'lead_archived_type.anotherbrand',
      'lead_archived_type.samebrand_dealership': 'lead_archived_type.samebrand_dealership',
      'lead_archived_type.anotherbrand_dealership': 'lead_archived_type.anotherbrand_dealership',
      'time.report.chart.contacted.customers': 'Núm. de clientes contactados',
      'time.report.chart.serie.contacted_leads': 'time.report.chart.serie.contacted_leads',
      'time.report.chart.serie.bussiness_contacted_leads': 'time.report.chart.serie.bussiness_contacted_leads',
      'time.report.chart.range.time.minutes': 'Intervalo de tempo (minutos)',
      'pages.metrics.sales.salesmen': 'Vendedores',
      'pages.metrics.sales.salesman': 'Vendedor',
      'pages.metrics.sales.salesman.unnasigned': 'Sem assignar',
      'pages.metrics.sales.leads': 'Leads',
      'pages.metrics.sales.archived.leads': 'Arquivados',
      'pages.metrics.sales.onTrack.leads': 'Em Seguimento',
      'pages.metrics.sales.contacted.leads': 'Contactados',
      'pages.metrics.sales.min.leads': 'Min/Lead',
      'pages.metrics.sales.visited.leads': 'Visitas',
      'pages.metrics.sales.closed.leads': 'Vendas',
      'pages.metrics.sales.interactions.count': 'Nº Interacções',
      'pages.metrics.sales.interactions.total': 'TOTAL',
      'channel.to.day.week.leads.chart.day.name': 'channel.to.day.week.leads.chart.day.name',
      'channel.to.day.week.leads.chart.day.name.monday': 'channel.to.day.week.leads.chart.day.name.monday',
      'channel.to.day.week.leads.chart.day.name.tuesday': 'channel.to.day.week.leads.chart.day.name.tuesday',
      'channel.to.day.week.leads.chart.day.name.wednesday': 'channel.to.day.week.leads.chart.day.name.wednesday',
      'channel.to.day.week.leads.chart.day.name.thursday': 'channel.to.day.week.leads.chart.day.name.thursday',
      'channel.to.day.week.leads.chart.day.name.friday': 'channel.to.day.week.leads.chart.day.name.friday',
      'channel.to.day.week.leads.chart.day.name.saturday': 'channel.to.day.week.leads.chart.day.name.saturday',
      'channel.to.day.week.leads.chart.day.name.sunday': 'channel.to.day.week.leads.chart.day.name.sunday',
      'channel.to.day.week.leads.chart.leads.count': 'channel.to.day.week.leads.chart.leads.count',
      'channel.to.day.week.leads.chart.bar': 'channel.to.day.week.leads.chart.bar',
      'channel.to.day.week.leads.chart.line': 'channel.to.day.week.leads.chart.line',
      'channel.to.day.week.leads.chart.stack': 'channel.to.day.week.leads.chart.stack',
      'channel.to.day.week.leads.chart.tiled': 'channel.to.day.week.leads.chart.tiled',
      'channel.to.day.week.leads.chart.undefined': 'channel.to.day.week.leads.chart.undefined',
      'channel.to.hour.leads.chart.undefined': 'Sem especificar',
      'channel.to.hour.leads.chart.stack': 'Empilhar',
      'channel.to.hour.leads.chart.tiled': 'Agrupar',
      'channel.to.hour.leads.chart.day.hour': 'Hora do dia',
      'channel.to.hour.leads.chart.leads.count': 'Número de Leads',
      'metrics.marketing.channel.leads.table.head.channel': 'Canal',
      'metrics.marketing.channel.leads.table.head.leads': 'Leads',
      'metrics.marketing.channel.leads.table.head.onTrack': 'Em Seguimento',
      'metrics.marketing.channel.leads.table.head.contacted': 'Contactados',
      'metrics.marketing.channel.leads.table.head.visited': 'Visitas',
      'metrics.marketing.channel.leads.table.head.closed': 'Vendas',
      'metrics.marketing.channel.leads.table.head.total': 'TOTAL',
      'metrics.marketing.channel.leads.table.channel.undefined': 'Sem específicar',
      'metrics.marketing.filter.description': 'Sem específicar',
      'toast.title.lead_archived_success': 'Lead arquivado',
      'toast.title.lead_close_error': 'Erro ao fechar a lead',
      'toasts.messages.lead_archived_success': 'A lead foi arquivada correctamente',
      'toasts.messages.lead_close_success': 'A lead foi fechada correctamente',
      'toast.title.appointment_date_success': 'Compromisso de Lead',
      'toasts.messages.appointment_date_success': 'Compromisso de lead guardado correctamente.',
      'dropdown.unknown': 'Indeterminado',
      'pages.security.change_password.title': 'Alterar password',
      'pages.security.change_password.password_placeholder': 'Nova password',
      'pages.security.change_password.password_validation_required': 'Nova password obrigatória',
      'pages.security.change_password.confirm_password_placeholder': 'Confirmar password',
      'pages.security.change_password.confirm_password_validation_required': 'Confirmação de password obrigatória',
      'pages.security.change_password.button_change_password': 'Alterar password',
      'pages.security.change_password.modals.error.title': 'Erro ao alterar password',
      'pages.security.change_password.modals.error.body': 'Por favor confirme as suas credenciais',
      'pages.security.change_password.modals.success.title': 'Alteração de password realizado com êxito',
      'pages.security.change_password.modals.success.body': 'Por favor inicie a sessão com a nova password',
      'pages.security.change_password.passwords_must_be_equals': 'As passwords devem ser iguais',
      'pages.security.change_password.password_validation_number': 'Deve conter pelo menos um número',
      'pages.security.change_password.password_validation_capital_case': 'Deve conter pelo menos uma maiuscula',
      'pages.security.change_password.password_validation_special_char': 'Deve conter pelo menos caractér especial',
      'pages.security.change_password.password_validation_min_length': 'Deve conter mais de %number% caracteres',
      'pages.security.change_password.password_validation_max_length': 'Deve conter menos de %number% caracteres',
      'pages.security.reset_password_email.email_required': 'E-mail obrigatório',
      'pages.security.reset_password_email.email_placeholder': 'E-mail',
      'pages.security.reset_password_email.button_reset_password': 'Reiniciar password',
      'pages.security.reset_password_email.title': 'Reiniciar password',
      'pages.security.reset_password_email.already_have_account': 'Já tem uma conta?',
      'pages.security.reset_password_email.sign_in': 'Identifica-te',
      'pages.security.reset_password_email.modals.error.title': 'Erro',
      'pages.security.reset_password_email.modals.error.body': 'Ocorreu um erro ao enviar el e-mail de recuperação',
      'pages.security.reset_password_email.modals.success.title': 'E-mail de reinicio de password enviado',
      'pages.security.reset_password_email.modals.success.body': 'Recebirá un link para recuperar a sua password',
      'pages.security.reset_password.modals.success.title': 'Password reiniciada correctamente',
      'pages.security.reset_password.modals.success.body': 'Por favor inicie sessão com a sua nova password',
      'pages.security.reset_password.modals.error.title': 'Erro',
      'pages.security.reset_password.modals.error.body': 'Ocorreu um erro ao reiniciar a password',
      'pwa.update_service.title': 'Nova versão disponível.',
      'pwa.update_service.body': 'DMSVO será actualizado automaticamente.',
      'template.import.header.name_and_lastname': 'Nome e apelidos',
      'template.import.header.phone': 'Telefone',
      'template.import.header.email': 'E-mail',
      'template.import.header.vat': 'NIF',
      'template.import.header.channel': 'Canal',
      'template.import.header.origin': 'Origen',
      'template.import.header.type': 'Tipo',
      'template.import.header.brand': 'Marca',
      'template.import.header.description_model': 'Modelo',
      'template.import.header.dealer': 'Instalação',
      'template.import.header.comment': 'Comentário',
      'template.import.name_file': 'Template',
      'error.validations.this_field_is_required': 'Este campo é obligatório',
      'error.lead_must_be_new_or_on_track': 'A Lead deve estar em estado novo ou seguimento',
      'error.validations.date_should_be_major_that_actual': 'A data indicada deve ser posterior à atual.',
      'error.email_is_not_valid': 'O e-mail não é válido',
      'error.not_found.company': 'Empresa não encontrada',
      'error.lead_assigned_another_user': 'A lead está assignada a outro utilizador',
      'error.lead_must_be_archived_or_on_track': 'A Lead deve estar arquivada ou em seguimento',
      'error.lead_in_call': 'Lead em chamada',
      'errors.event_no_added': 'errors.event_no_added',
      'errors.event_should_date_greater_that_current': 'errors.event_should_date_greater_that_current',
      'call.started.call': 'Chamada em curso: ',
      'call.has.another.started.call': 'Tem outra chamada em curso.',
      'call.view.lead': 'Ver Lead',
      'call.view.lead_with_link': 'Tem outro lead em chamada. Ver Lead',
      'error.user_in_call': 'Utilizador numa chamada',
      'error.lead_closed': 'A Lead não está fechada',
      'error.not_found.lead': 'Lead não encontrada',
      'error.lead_allready_assigned': 'A Lead já está assignada',
      'error.operation_not_allowed': 'Operação não permitida',
      'error.duplicated_session.title': 'Sessão duplicada',
      'error.duplicated_session.body': 'Sessão iniciada em outro dispositivo',
      'error.found.external_system': 'Esse lead já foi enviado ao sistema externo',
      'error.not_found.external_system': 'Sistema externo não encontrado',
      'error.thrift_response.integration': 'Erro ao integrar o lead com o sistema externo',
      'menu.metrics.title': 'Métricas',
      'menu.metrics.sales.title': 'Vendas',
      'menu.metrics.marketing.title': 'Marketing',
      'menu.analytics.title': 'Análise',
      'menu.login.title': 'Login',
      'menu.login.change.password.title': 'Alterar password',
      'menu.login.logout.title': 'Desconectar',
      'menu.leads.title': 'Leads',
      'menu.reporting.title': 'menu.reporting.title',
      'menu.dashboard': 'menu.dashboard',
      'menu.working_hours': 'menu.working_hours',
      'auth.labels.logout': 'Desconectar',
      'filters.title': 'Filtros',
      'filters.select_range_of_dates': 'filters.select_range_of_dates', // TODO translate
      'filters.has_appointment_filter_token': 'Leads con compromissos',
      'filters.contact.undefined': 'Nome / E-mail / Telefone',
      'filters.filter_by_name': 'Nome',
      'filters.filter_by_email': 'E-mail',
      'filters.filter_by_phone': 'Telefone',
      'filters.error.three_chars_needed.text': '* Deve conter pelo menos 3 caracteres',
      'filters.error.three_chars_needed.phone': '* Deve conter pelo menos 3 dígitos',
      'filters.in_call': 'De plantão',
      'filters.transferred_not_received': 'Transf. não recebido',
      'time.abrv_seconds': ' seg ',
      'time.abrv_minutes': ' min ',
      'time.abrv_hours': ' h ',
      'pages.marketing.inboud_leads_per_channels_day_week': 'pages.marketing.inboud_leads_per_channels_day_week',
      'pages.marketing.inboud_leads_per_channels': 'Entrada de Leads por canal',
      'pages.sales.sales_funnel': 'Funil de Vendas',
      'pages.sales.sales_funnel.on_track': 'Em seguimento',
      'pages.sales.sales_funnel.archived': 'Arquivado',
      'pages.marketing.conversion_indicators': 'Indicadores de conversão',
      'pages.marketing.leads': 'Leads',
      'pages.marketing.on_track': 'Em seguimento',
      'pages.marketing.contacted': 'Contactados',
      'pages.marketing.visited': 'Visitas',
      'pages.marketing.sales': 'Vendas',
      'pages.sales.time_reports': 'Tempo de resposta das Leads',
      'pages.sales.time_reports_by_user': 'pages.sales.time_reports_by_user',
      'pages.historic.inboud_leads': 'Entrada de Lead',
      'pages.historic.duration_interaction': 'Duração da interacção',
      'pages.historic.not_contacted': 'Não contactada',
      'pages.historic.status_label': 'Lead etiquetada',
      'pages.historic.lead_assigned_to': 'Lead assignada',
      'pages.historic.lead_transfered_to': 'Lead transferida',
      'pages.historic.scheduled_appointment': 'Compromisso agendado',
      'pages.historic.for_the_day': ' para o dia ',
      'pages.historic.at': 'às',
      'pages.historic.show_mail': 'pages.historic.show_mail',
      'pages.historic.hidden_mail': 'pages.historic.hidden_mail',
      'pages.historic.show_whatsapp': 'pages.historic.show_whatsapp',
      'pages.historic.hidden_whatsapp': 'pages.historic.hidden_whatsapp',
      'pages.schedule.no_future_events': 'pages.schedule.no_future_events',
      'pages.schedule.events_to_manage': 'pages.schedule.events_to_manage',
      'pages.reporting.tabtitle.bdc': 'pages.reporting.tabtitle.bdc',
      'pages.reporting.tabtitle.leads': 'pages.reporting.tabtitle.leads',
      'pages.reporting.tabtitle.sales': 'pages.reporting.tabtitle.sales',
      'pages.reporting.tabtitle.marketing': 'pages.reporting.tabtitle.marketing',
      'pages.reporting.bdc.bdctimes': 'pages.reporting.bdc.bdctimes',
      'pages.reporting.download': 'pages.reporting.download',
      'header.select_company': 'header.select_company',
      'table.no_data_display': 'table.no_data_display', // TODO translate
      'calendar.add_event': 'calendar.add_event',
      'chat.show_hidden': 'chat.show_hidden',
      'info.coming_soon': 'Em breve',
      'metric_lead.created_at.title': 'Data de entrada do lead:',
      'metric_lead.updated_at.title': 'Data da última modificação:',
      'metric_lead.first_assignedDate.title': 'Data da primeira tarefa:',
      'metric_lead.first_user_assigned.title': 'Primeiro usuário designado:',
      'metric_lead.first_interaction_date.title': 'Data da primeira interação:',
      'metric_lead.first_contact_user.name': 'Usuário que faz o primeiro contato:',
      'metric_lead.real_response_time.title': 'Tempo de resposta (real):',
      'metric_lead.first_contact_bussiness.title': 'Tempo de resposta (horário comercial):',
      'metric_lead.first_contact_date.title': 'Data do primeiro contato:',
      'metric_lead.end_defeat_date.title': 'Data da próxima expiração:',
      'metric_lead.transferred.title': 'Transferência de recibo pendente:',
      'metric_lead.first_call_date.title': 'Data da primeira chamada:',
      'metric_lead.call_start_time.title': 'Data de início da chamada atual:',
      'metric_lead.times_transferred.title': 'Número de vezes transferido:',
      'metric_lead.times_edited.title': 'Número de vezes editado:',
      'metric_lead.times_without_call_response.title': 'Número de chamadas não atendidas:',
      'metric_lead.times_with_call_response.title': 'Número de chamadas atendidas:',
      'metric_lead.whatsapps_sent.title': 'Número de Whastapp enviou:',
      'metric_lead.emails_sent.title': 'Número de e-mails enviados:',
      'metric_lead.emails_received.title': 'Número de e-mails recebidos:',
      'metric_lead.reminders_scheduled.title': 'Número de lembretes agendados:',
      'metric_lead.appointment_scheduled.title': 'Número de compromissos agendados:',
      'metric_lead.total_interactions.title': 'Total de interações:',
      'response.yes': 'Sim',
      'response.no': 'Não',
      'info.new_content': 'Novo!',
      'planning.date': 'Encontro',
      'planning.user': 'Usuário',
      'planning.lead': 'Lead',
      'planning.company': 'planning.company',
      'planning.comment': 'Comentário',
      'planning.getting_events': 'planning.getting_events',
      'planning.no_events': 'planning.no_events',
      'user.profile': 'user.profile',
      'user.rules': 'user.rules',
      'user.email': 'user.email',
      'user.schedule': 'user.schedule',
      'user.password': 'user.password',
      'user.save_signature': 'user.save_signature',
      'user.role.legend': 'user.role.legend',
      'user.role.role_superadmin': 'user.role.role_superadmin',
      'user.role.role_user': 'user.role.role_user',
      'user.role.role_admin': 'user.role.role_admin',
      'user.role.role_bdc': 'user.role.role_bdc',
      'user.role.role_dapda': 'user.role.role_dapda',
      'filters.no_report': 'filters.no_report',
      'filters.yes_come': 'filters.yes_come',
      'filters.not_come': 'filters.not_come',
      'pages.leads.no_potencial_sellers': 'pages.leads.no_potencial_sellers',
      'pages.leads.potencial_sellers': 'pages.leads.potencial_sellers',
      'pages.leads.accessible_lead': 'pages.leads.accessible_lead',
      'pages.leads.quotation.loading': 'pages.leads.quotation.loading',
      'pages.leads.quotation.vehicle': 'pages.leads.quotation.vehicle',
      'pages.leads.quotation.amount': 'pages.leads.quotation.amount',
      'pages.leads.quotation.status': 'pages.leads.quotation.status',
      'pages.leads.quotation.creationDate': 'pages.leads.quotation.creationDate',
      'pages.leads.quotation.dates': 'pages.leads.quotation.dates',
      'pages.leads.quotation.modificationDate': 'pages.leads.quotation.modificationDate',      
      'pages.leads.quotation.quotationCreation': 'pages.leads.quotation.quotationCreation',
      'pages.leads.quotation.quotationModification': 'pages.leads.quotation.quotationModification',
      'pages.leads.quotation.contractDate': 'pages.leads.quotation.contractDate',
      'pages.leads.quotation.saleDate': 'pages.leads.quotation.saleDate',      
      'pages.leads.quotation.quotationSoldClosingComment': 'pages.leads.quotation.quotationSoldClosingComment',      
      'brand.leads.chart.no_brand': 'brand.leads.chart.no_brand',
      'help.assignment_rules_configuration': 'help.assignment_rules_configuration',
      'pages.profile.rules.positive_rules': 'pages.profile.rules.positive_rules',
      'pages.profile.rules.active': 'pages.profile.rules.active',
      'toaster.new.rule.unhandled_error': 'toaster.new.rule.unhandled_error',
      'toaster.new.repeated_rule.error.title': 'toaster.new.repeated_rule.error.title',
      'toaster.new.repeated_rule.error.body': 'toaster.new.repeated_rule.error.body',
      'help.assignment_rules.simulator': 'help.assignment_rules.simulator',
      'legend.filter.last_modification': 'legend.filter.last_modification',
      'leadType.appraisal': 'leadType.appraisal',
      'leadType.spare_parts': 'leadType.spare_parts',
      'chart.lead_type.appraisal': 'chart.lead_type.appraisal',
      'chart.lead_type.spare_parts': 'chart.lead_type.spare_parts',
      'pages.leads.type.appraisal': 'pages.leads.type.appraisal',
      'pages.leads.type.spare_parts': 'pages.leads.type.spare_parts',
      'pages.mylead.details.appraisal': 'pages.mylead.details.appraisal',
      'pages.mylead.details.spare_parts': 'pages.mylead.details.spare_parts',
      'leadType.km0': 'leadType.km0',
      'chart.lead_type.km0': 'chart.lead_type.km0',
      'pages.leads.type.km0': 'pages.leads.type.km0',
      'pages.mylead.details.km0': 'pages.mylead.details.km0',
      'error.fail_comunications_with_woice': 'error.fail_comunications_with_woice',
      'error.woice_token_not_received': 'error.woice_token_not_received',
    };

}
